<template lang="pug">
router-view
</template>

<script lang="ts">
import { defineComponent } from "vue";
export default defineComponent({});
</script>
